import type { ThemeConfig } from "antd";
import { theme } from "antd";

import { darkTheme, lightTheme } from "./theme";

export const antdCommonConfig: ThemeConfig["components"] = {
    Typography: {
        fontFamily: "Inter",
    },
    Button: {
        colorPrimary: "#3A57E8",
        colorSuccessBg: "#52C41A",
        borderRadius: 50,
        fontSize: 16,
    },
    Card: {
        actionsBg: "#212121",
    },
    Select: {
        fontSizeSM: 12,
        fontSize: 14,
        fontSizeLG: 16,
        controlHeightSM: 24,
        controlHeight: 32,
        controlHeightLG: 40,
        zIndexPopup: 9999,
        optionActiveBg: "transparent",
        multipleItemHeightLG: 34,
        multipleItemHeight: 26,
        multipleItemHeightSM: 18,
    },
    DatePicker: {
        inputFontSizeSM: 12,
        inputFontSize: 14,
        inputFontSizeLG: 16,
        controlHeightSM: 24,
        controlHeight: 32,
        controlHeightLG: 40,
    },
    Segmented: {
        trackPadding: "5px",
    },
    Collapse: {
        headerPadding: "16px",
        fontSize: 16,
    },
    Carousel: {
        arrowSize: 20,
    },
    Input: {
        fontSizeSM: 12,
        fontSize: 14,
        fontSizeLG: 16,
        controlHeightSM: 24,
        controlHeight: 32,
        controlHeightLG: 40,
    },
};

export const antdLightTheme: ThemeConfig = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorError: lightTheme.dangerTypographyColor,
        colorErrorText: lightTheme.dangerTypographyColor,
        colorText: lightTheme.primaryTypographyColor,
    },
    components: {
        ...antdCommonConfig,
        Typography: {
            ...antdCommonConfig.Typography,
            colorPrimary: lightTheme.primaryTypographyColor,
        },
        Collapse: {
            ...antdCommonConfig.Collapse,
            contentBg: "#e7e7e7",
            headerBg: lightTheme.collapseHeaderBackground,
        },
        Layout: {
            headerBg: "#e7e7e7",
            headerColor: "#ffffff",
            footerBg: "#e7e7e7",
        },
    },
};

export const antdDarkTheme: ThemeConfig = {
    algorithm: theme.darkAlgorithm,
    token: {
        colorError: darkTheme.dangerTypographyColor,
        colorErrorText: darkTheme.dangerTypographyColor,
        colorText: darkTheme.primaryTypographyColor,
    },
    components: {
        ...antdCommonConfig,
        Typography: {
            ...antdCommonConfig.Typography,
            colorPrimary: darkTheme.primaryTypographyColor,
        },
        Collapse: {
            ...antdCommonConfig.Collapse,
            contentBg: "#141414",
            headerBg: darkTheme.collapseHeaderBackground,
        },
        Layout: {
            headerBg: "#181818",
            headerColor: "#000000",
            footerBg: "#181818",
        },
    },
};
